/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droparchive1Inputs */

const en_droparchive1 = /** @type {(inputs: Droparchive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

const de_droparchive1 = /** @type {(inputs: Droparchive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivieren`)
};

/**
* | output |
* | --- |
* | "Archive" |
*
* @param {Droparchive1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droparchive1 = /** @type {((inputs?: Droparchive1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droparchive1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droparchive1(inputs)
	return de_droparchive1(inputs)
});
export { droparchive1 as "dropArchive" }